import { DEFAULT_LOCALE as P } from "../../constants/locale.js";
import { createStrictContext as x } from "../../util/context/createStrictContext.js";
import { underscoreLocale as C } from "../../util/i18n/helper/locale.js";
import { singleOperation as v } from "../../util/operation/singleOperation.js";
import { useRouter as y } from "next/router";
import * as e from "ramda";
import { useMemo as L, useState as K, useCallback as c } from "react";
import { jsx as _ } from "react/jsx-runtime";
const [h, b] = x("Preload"), g = (i) => {
  const {
    children: m
  } = i, {
    locale: s
  } = y(), l = L(() => C(s || P), [s]), [r, p] = K({}), n = c((t) => `preload_${t}_${l}`, [l]), u = c(async (t, d) => {
    const o = n(t);
    if (e.has(o, r))
      return e.prop(o, r);
    {
      const a = await v(o, d);
      return e.isNotNil(a) && p((f) => e.assoc(o, a, f)), a;
    }
  }, [r, n]);
  return /* @__PURE__ */ _(h, {
    value: {
      preloadValue: u
    },
    children: m
  });
};
export {
  g as PreloadProvider,
  b as usePreloadContext
};
//# sourceMappingURL=PreloadContext.js.map
